<template>
  <div id="app">
    <router-view />
    <ui-black-overlay />
    <ui-flash-message/>
  </div>
</template>

<script>
import UiBlackOverlay from "@/components/common/BlackOverlay.vue";
import UiFlashMessage from "@/components/common/FlashMessage.vue";

export default {
  name: "App",
  components: {
    UiBlackOverlay,
    UiFlashMessage,
  },
};
</script>

<style lang="scss">
</style>
